import styled from '@emotion/styled'

import {
  AUFlagIcon,
  BBFlagIcon,
  CAFlagIcon,
  GBFlagIcon,
  KYFlagIcon,
  NZFlagIcon,
  USFlagIcon,
  VNFlagIcon,
  InfoIcon,
  BusinessNameIcon,
  AddressIcon,
  ClientNameIcon,
  EmailIcon,
  LocationIcon,
  PhoneIcon,
  SearchIcon,
  AddIcon,
  ViewIcon,
  LocationPin,
  LocationFilledPin,
  SingleLocationIcon,
  MultiLocationIcon,
  BuildingIcon,
  CloseIcon,
  CalendarIcon,
  MailIcon,
  LocIcon,
  TelIcon,
  IdCardIcon,
  CalendarDayIcon,
  ChooseIcon,
  FileInvoiceDollarIcon,
  FeaturesIcon,
  Features1Icon,
  ManageIcon,
  OrderIcon,
  LinkIcon,
  DeleteIcon,
  FwdArrowIcon,
  BackArrowIcon,
  NoOrderIcon,
  PromoCodeIcon,
} from '.'

// shared styles
const mixBlendMode = `
  * {
    mix-blend-mode: normal !important;
  }
`

// reusable icon factory
const createIcon = (Icon, size = 12, extraStyles = '') =>
  styled(Icon)`
    width: ${size}px;
    height: ${size}px;
    flex-shrink: 0;
    color: ${({color}) => color || 'inherit'};

    ${extraStyles}
  `

const createFlagIcon = Icon => createIcon(Icon, 24, mixBlendMode)

const createFormIcon = (Icon, size) => createIcon(Icon, size, mixBlendMode)

// flags
export const StyledUSFlagIcon = createFlagIcon(USFlagIcon)

export const StyledCAFlagIcon = createFlagIcon(CAFlagIcon)

export const StyledAUFlagIcon = createFlagIcon(AUFlagIcon)

export const StyledNZFlagIcon = createFlagIcon(NZFlagIcon)

export const StyledGBFlagIcon = createFlagIcon(GBFlagIcon)

export const StyledBBFlagIcon = createFlagIcon(BBFlagIcon)

export const StyledKYFlagIcon = createFlagIcon(KYFlagIcon)

export const StyledVNFlagIcon = createFlagIcon(VNFlagIcon)

// form icons
export const StyledInfoIcon = createFormIcon(InfoIcon)

export const StyledBusinessNameIcon = createFormIcon(BusinessNameIcon)

export const StyledAddressIcon = createFormIcon(AddressIcon)

export const StyledClientNameIcon = createFormIcon(ClientNameIcon)

export const StyledEmailIcon = createFormIcon(EmailIcon)

export const StyledLocationIcon = createFormIcon(LocationIcon)

export const StyledPhoneIcon = createFormIcon(PhoneIcon)

// other icons
export const StyledSearchIcon = createFormIcon(SearchIcon, 16)

export const StyledAddIcon = createFormIcon(AddIcon, 16)

export const StyledViewIcon = createFormIcon(ViewIcon, 16)

export const StyledLocationPinIcon = createFormIcon(LocationPin, 16)

export const StyledLocationFilledPinIcon = createFormIcon(LocationFilledPin, 20)

export const StyledSingleLocationIcon = createFormIcon(SingleLocationIcon, 16)

export const StyledMultiLocationIcon = createFormIcon(MultiLocationIcon, 16)

export const StyledBuildingIcon = createFormIcon(BuildingIcon, 20)

export const StyledCloseIcon = createFormIcon(CloseIcon, 20)

export const StyledCalendarIcon = createFormIcon(CalendarIcon, 20)

export const StyledMailIcon = createFormIcon(MailIcon, 20)

export const StyledLocIcon = createFormIcon(LocIcon, 20)

export const StyledLocIconSm = createFormIcon(LocIcon, 12)

export const StyledTelIcon = createFormIcon(TelIcon, 20)

export const StyledIdCardIcon = createFormIcon(IdCardIcon, 20)

export const StyledCalendarDayIcon = createFormIcon(CalendarDayIcon, 20)

export const StyledChooseIcon = createFormIcon(ChooseIcon, 20)

export const StyledFeaturesIcon = createFormIcon(FeaturesIcon, 20)

export const StyledFeatures1Icon = createFormIcon(Features1Icon, 20)

export const StyledManageIcon = createFormIcon(ManageIcon, 20)

export const StyledOrderIcon = createFormIcon(OrderIcon, 20)

export const StyledLinkIcon = createFormIcon(LinkIcon, 16)

export const StyledDeleteIcon = createFormIcon(DeleteIcon, 16)

export const StyledFwdArrowIcon = createFormIcon(FwdArrowIcon, 20)

export const StyledBackArrowIcon = createFormIcon(BackArrowIcon, 20)

export const StyledFileInvoiceDollarIcon = createFormIcon(
  FileInvoiceDollarIcon,
  20,
)

export const StyledNoOrderIcon = createFormIcon(NoOrderIcon, 93)
export const StyledPromoCodeIcon = createFormIcon(PromoCodeIcon, 18)
